import axios from "axios";
import React, {useState, useEffect} from "react";
import "./AdminCom.css"

const PostUsers = () => {
    const qs = require("qs");
    const [categories, setCategories] = useState([]);

    console.log(categories)

    const [image, setImage] = useState("");
    const [nameEn, setNameEn] = useState("");
    const [nameRu, setNameRu] = useState("");
    const [nameUz, setNameUz] = useState("");
    const [descriptionEn, setDescriptionEn] = useState("");
    const [descriptionRu, setDescriptionRu] = useState("");
    const [descriptionUz, setDescriptionUz] = useState("");
    const [uuid, setUuid] = useState("");
    const [price, setPrice] = useState("");


   const handlerClick = (e) => {
       axios.post("https://kudapizza.herokuapp.com/pizzas/", {
           name_en: nameEn,
           name_ru: nameRu,
           name_uz: nameUz,
           description_en: descriptionEn,
           description_ru: descriptionRu,
           description_uz: descriptionUz,
           image: image,
           price: price,
           category: uuid,
       })

           .then((res) => {
               console.log("server res:", res)
               window.location.reload();
           })
           .catch((err) => {
               console.log("server err:", err)
           })
    
       }
    useEffect(() => {
        axios
            .get("https://kudapizza.herokuapp.com/categories/")
            .then((res) => {
                setCategories(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);
           return (

        <div className="main__PostUsers">
            <h1>Add New Product:</h1>
            <div className="forms">


                <input placeholder="Name"
                       type="text"
                       value={nameEn}
                       onChange={(e) => setNameEn(e.target.value)}
                />
                <input placeholder="Nameru"
                       type="text"
                       value={nameRu}
                       onChange={(e) => setNameRu(e.target.value)}
                />
                <input placeholder="Nameuz"
                       type="text"
                       value={nameUz}
                       onChange={(e) => setNameUz(e.target.value)}
                />
                <input placeholder="Price"
                       type="text"
                       value={price}
                       onChange={(e) => setPrice(e.target.value)}
                />
                <input placeholder="deskuz"
                       type="text"
                       value={descriptionUz}
                       onChange={(e) => setDescriptionUz(e.target.value)}
                />
                <input placeholder="desckru"
                       type="text"
                       value={descriptionRu}
                       onChange={(e) => setDescriptionRu(e.target.value)}
                />

                <input placeholder="desken"
                       type="text"
                       value={descriptionEn}
                       onChange={(e) => setDescriptionEn(e.target.value)}
                />
                <select
                    value={uuid}
                    onChange={(e) => setUuid(e.target.value)}
                >
                    {categories.map((el) => {
                        return (
                            <option key={el.id} style={{ color: "white" }} value={el.id}>
                                {el.name_ru}
                            </option>
                        );
                    })}
                </select>
                <input placeholder="URL"
                       type="text"
                       value={image}
                       onChange={(e) => setImage(e.target.value)}
                />


            </div>
            <button className="glow_on_hover btnn" onClick={handlerClick}>Add</button>
        </div>
    );
};

export default PostUsers;